import * as types from './types'
import PaymentMethodResource from '@/common/resources/PaymentMethod'

export const actions = {
	getPaymentMethods ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.CLEAR_PAYMENT_METHOD)
			PaymentMethodResource.getPaymentMethods().then((result) => {
				if (result.data.success) {
					commit(types.STRIPE_CLIENT_SECRET, result.data.client_secret)
					result.data.payment_methods.forEach((paymentMethod) => {
						commit(types.NEW_PAYMENT_METHOD, paymentMethod)
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					if (result.data.error === 'No paymentMethods found.') {
						resolve()
					} else {
						reject(new Error('Dont know'))
					}
				}
			}).catch((e) => {
				commit('LOADER_OUT')
				reject(e)
			})
		})
	},
	newPaymentMethod ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			PaymentMethodResource.newPaymentMethod(data).then((result) => {
				if (result.data.success) {
					commit(types.NEW_PAYMENT_METHOD, result.data.payment_method)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	editPaymentMethod ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			PaymentMethodResource.editPaymentMethod(data.payment_method_id, data).then((result) => {
				if (result.data.success) {
					commit(types.EDIT_PAYMENT_METHOD, result.data.payment_method)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	deletePaymentMethod ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			PaymentMethodResource.deletePaymentMethod(data.payment_method_id).then((result) => {
				if (result.data.success) {
					commit(types.DELETE_PAYMENT_METHOD, data.payment_method_id)
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/common/store/PaymentMethod/actions.js